import Vue from "vue";
import { scenes, cards } from "@/consts/consts.ts";
import Header from "@/components/Header.vue";
import Prologue from "@/components/Prologue.vue";
import Board from "@/components/Board.vue";
import Bank from "@/components/Bank.vue";
import Casino from "@/components/Casino.vue";
import Hotel from "@/components/Hotel.vue";
import Apart from "@/components/Apart.vue";
import Castle from "@/components/Castle.vue";
import Footer from "@/components/Footer.vue";
export default Vue.extend({
    name: "Home",
    components: {
        Header,
        Prologue,
        Board,
        Bank,
        Casino,
        Hotel,
        Apart,
        Castle,
        Footer
    },
    data() {
        return {
            scenes: scenes,
            // その位置のイベントをクリアしたことを示す
            // -1: 初期値
            // 0: 説明＆プレイヤー選択
            // 1: プロローグ
            // 2: ボード到着
            // 3: 銀行到着
            // 4: カジノ到着
            // 5:
            cleared: scenes.PROLOGUE,
            selected: scenes.PROLOGUE,
            // 0: init, 1: player1, 2: player2
            player: 0,
            cards: Array()
        };
    },
    methods: {
        selectScene(scene) {
            this.selected = scene;
        },
        clearPrologue() {
            if (this.cleared <= scenes.BOARD)
                this.cleared = scenes.BOARD;
            this.selected = scenes.BOARD;
            this.cards.push(cards.PROLOGUE);
        },
        reachBank() {
            if (this.cleared <= scenes.BANK)
                this.cleared = scenes.BANK;
            this.selected = scenes.BANK;
        },
        reachCasino() {
            if (this.cleared <= scenes.CASINO)
                this.cleared = scenes.CASINO;
            this.selected = scenes.CASINO;
        },
        reachHotel() {
            if (this.cleared <= scenes.HOTEL)
                this.cleared = scenes.HOTEL;
            this.selected = scenes.HOTEL;
        },
        reachApart() {
            if (this.cleared <= scenes.APART)
                this.cleared = scenes.APART;
            this.selected = scenes.APART;
        },
        reachCastle() {
            if (this.cleared <= scenes.CASTLE)
                this.cleared = scenes.CASTLE;
            this.selected = scenes.CASTLE;
        },
        reachLast() {
            this.$router.push({ path: "/clear", query: { pass: "bqwyzvxa" } });
        }
    },
    mounted() {
        if (!this.$route.query.player) {
            this.$router.push({ path: "/" });
        }
        document.title = this.$route.name || "すごろーく - プレイ";
        this.$gtag.pageview({
            // eslint-disable-next-line @typescript-eslint/camelcase
            page_path: this.$route.path,
            // eslint-disable-next-line @typescript-eslint/camelcase
            page_title: this.$route.name || undefined
        });
        this.player = +this.$route.query.player;
    }
});
